import { noop } from "motion";
import { useEffect, useState } from "react"

class GeolocationStore {
  key = "_fp_GeolocationStorePayload"
  get() {
    const textResponse = localStorage.getItem(this.key);
    if (!textResponse) return {};

    try {
      return JSON.parse(atob(textResponse));
    } catch (error) {
      this.clear();
      return {};
    }
  }

  set({ latitude, longitude }) {
    localStorage.setItem(
      this.key,
      btoa(JSON.stringify({ latitude, longitude })),
    );
  }

  clear() {
    localStorage.removeItem(this.key);
  }
}

async function fetchGeolocation() {
  const response = await fetch('https://speed.cloudflare.com/meta');
  if (response.status !== 200) {
    throw new Error(`HTTP Error ${response.status}`);
  }

  return response.json();
}

export default function useIpData() {
  const [geolocation, setGeolocation] = useState({});
  const [error, setError] = useState(null);

  useEffect(() => {
    const store = new GeolocationStore();
    const fetchAndSetGeolocation = async () => {
      try {
        const { latitude, longitude } = await fetchGeolocation();
        store.set({ latitude, longitude });
        setGeolocation({ latitude, longitude });
      } catch (error) {
        if (error.message.includes("HTTP Error")) {
          return setError("Failed to fetch location");
        }
        throw error;
      }
    }

    const { latitude, longitude } = store.get();

    if (latitude && longitude) {
      setGeolocation({ latitude, longitude });
      return noop;
    }

    fetchAndSetGeolocation();
  }, []);

  return { ...geolocation, error };
}
